import React from 'react';
import PropTypes from 'prop-types';


import AutopromoTypes from 'src/types/Autopromo';
import AutopromoContentContainer from 'src/containers/AutopromoContentContainer';
import AutopromoPicture from 'src/components/AutopromoPicture';
import 'src/containers/AutopromoContainer.scss';


const AutopromoContainer = ({
  data: {
    containerAlign,
    isCenterAlign,
    darkFontVersion,
    imgUrl,
    altText,
    title,
    subtitle,
    buttons,
    slideDesktop
  },
  images
}) => (
  <div data-test="section_autopromo" styleName="autopromo">
    <AutopromoPicture
      altText={ altText }
      images={ images }
      imgUrl={ imgUrl }
    />
    <AutopromoContentContainer
      buttonsMobile={ buttons }
      containerAlign={ containerAlign }
      darkFontVersion={ darkFontVersion }
      isCenterAlign={ isCenterAlign }
      subtitleMobile={ subtitle }
      titleMobile={ title }
      { ...slideDesktop }
    />
  </div>
);

AutopromoContainer.propTypes = {
  data: PropTypes.exact(AutopromoTypes),
  images: PropTypes.shape({
    desktop1x: PropTypes.string,
    desktop2x: PropTypes.string,
    mobile1x: PropTypes.string,
    mobile2x: PropTypes.string,
    mobile3x: PropTypes.string
  })
};

AutopromoContainer.defaultProps = {
  data: {},
  images: {}
};

export default AutopromoContainer;
